import {ICustomers} from '../../../api/analyticsCustomers/types';
import moment from 'moment';
import {dateWithFullTimeFormat} from '../../../globalConstants';

export const selectAnalyticsCustomers = (state: ICustomers) => state.analyticsCustomers.data.result;
export const selectTotalRecords = (state: ICustomers) => state.analyticsCustomers.data.page.total;
export const selectLastUpdateDate = (state: ICustomers) =>
    moment(state.analyticsCustomers.data.lastUpdateDate).format(dateWithFullTimeFormat.US);
